import React from 'react';
import { Button, Box, Text } from '@withjoy/joykit';
import { EnhancedStack, ButtonStack } from './styles';
import { CurrentUser } from '@graphql/types';
import { useAnalytics } from '@withjoy/web-core';

interface ExistingAccountProps {
  currentUser: CurrentUser;
  eventUrl: string;
  handleLogout: () => void;
  proceed: () => void;
}
export const ExistingAccount: React.SFC<ExistingAccountProps> = ({ eventUrl, handleLogout, proceed }) => {
  const { track } = useAnalytics({
    pagePrefix: 'marketing',
    category: 'CreateWedding',
    page: 'existingEvent'
  });

  const onClickLogout = () => {
    track({ action: 'LogoutContinue', actionType: 'click', label: 'logout and continue' });
    handleLogout();
  };

  const onClickProceed = () => {
    track({ action: 'ExistingWebsite', actionType: 'click' });
    proceed();
  };

  return (
    <Box padding={{ xs: '1rem', md: '6rem' }} marginBottom="10rem">
      <EnhancedStack spacing="xs">
        <Text component="h1" variant="page">
          Looks like you already made
        </Text>
        <Text component="h2" variant="title">{`withjoy.com/${eventUrl}`}</Text>
        <Text component="p" variant="body">
          Right now we support only one website per account.
        </Text>
        <Text component="p" variant="caption">
          If you would like to create a second site, please first logout of your account and sign up with a different
          email.
        </Text>
        <ButtonStack vertical={false} stackVerticalOnMobile={true} spacing="sm">
          <Button onClick={onClickProceed}>Proceed to Website</Button>
          <Button onClick={onClickLogout}>Logout and Continue</Button>
        </ButtonStack>
      </EnhancedStack>
    </Box>
  );
};
